import React, { useContext, useState } from 'react'
import { AppContext } from '@state/context'
import Heading from '@components/Heading'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  COLORS,
  DIVIDER_SIZE,
  HEADING_TYPE,
  PANELS,
  TEXT_ALIGN,
  TEXT_SIZES,
} from '@helpers/constants'
import Divider from '@components/Divider'
import ButtonWithLoader from '@components/ButtonWithLoader'
import Text from '@components/Text'
import Button from '@components/Button'
import { closePanel } from '@state/actions/panelsActions'
import { useGenerateStudentPassword } from '@hooks/mutations/useGenerateStudentPassword'

const HandleStudentPassword = () => {
  const [state, dispatch] = useContext(AppContext)
  const [copied, setCopied] = useState(false)
  const student = state.panels?.panelData?.student
  const [pin, setPin] = useState()
  const { post, isLoading} = useGenerateStudentPassword()

  const onSubmit = async () => {
    const res = await post({ studentId: student.id }, undefined, 'Något gick fel. Försök igen och kontakta oss om felet kvarstår.')

    if (res.success) {
      setPin(res.generateStudentPassword.password)
    }
  }

  return (
    <>
      <div className={'relative'}>
        <div className='absolute top-0 right-0'>
          <Button
            handleClick={() => {
              dispatch(closePanel(PANELS.HANDLE_STUDENT_PASSWORD))
            }}
            size={BUTTON_SIZE.NO_PADDING}
            icon={'Close'}
          />
        </div>
      </div>

      <div className={'flex flex-col items-start'}>
        <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.LARGE}>
          {pin ?
            `Nytt lösenord skapat för "${ student?.username ?? (student?.first_name + ' ' + student?.last_name) }"`
            :
            `Skapa nytt lösenord för "${ student?.username ?? (student?.first_name + ' ' + student?.last_name) }"`
          }
        </Heading>

        {pin &&
          <div className="flex flex-col gap-4 items-start">
            <Text>Ge detta lösenord till eleven (till exempel kopiera och klistra in i ett mejl).</Text>
            <div className={'inline-block py-2 pl-4 pr-10 bg-lightLightGrey'}>
              {pin}
            </div>
            <div className="flex gap-4">
              <Button
                type={BUTTON_TYPE.PRIMARY}
                size={BUTTON_SIZE.MEDIUM}
                handleClick={() => {
                  navigator.clipboard.writeText(pin)
                  setCopied(true)
                }}
              >
                Kopiera
              </Button>
              <Text extraClasses={'ml-4'} color={COLORS.LIGHT_DARK_GREY.TEXT}>
                {copied &&
                  'Länk kopierad!'
                }
              </Text>
            </div>
          </div>
        }

        {!pin?.length &&
          <>
            <Text align={TEXT_ALIGN.LEFT}>
              Det gamla kommer att sluta gälla.
            </Text>
            <Divider size={DIVIDER_SIZE.SMALL} />
          </>
        }

        {!pin && (
          <ButtonWithLoader
            type={BUTTON_TYPE.PRIMARY}
            isLoading={isLoading}
            enabledText={'Skapa lösenord'}
            disabled={isLoading || pin?.length > 0}
            handleClick={onSubmit}
          />
        )}
      </div>
    </>
  )
}

export default HandleStudentPassword
